export default "__VITE_ASSET__b0edc8a1__"